var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,2.2C15.6,2.2,2.2,15.6,2.2,32S15.6,61.8,32,61.8c16.4,0,29.8-13.3,29.8-29.8S48.4,2.2,32,2.2z M33.4,10.7 l9.8-3.3c3.3,1.5,6.3,3.7,8.8,6.4l0,10.4l-8.7,2.1l-9.9-7.2V10.7z M20.8,7.5l9.8,3.2v8.4l-9.9,7.2l-8.6-2.1l0-9.8 c0-0.2-0.1-0.3-0.1-0.5C14.4,11.2,17.4,9,20.8,7.5z M8.5,45.2C6.8,42.1,5.6,38.7,5.2,35l6.1-8.1l8.6,2.1l3.8,11.6l-5.4,7.9 L8.5,45.2z M37.2,58.5C35.5,58.8,33.8,59,32,59c-2,0-3.9-0.2-5.7-0.6l-5.8-8.2l5.4-7.9h12.2l4.9,7.9L37.2,58.5z M45.2,48.4 l-4.9-7.9L44.1,29l8.7-2.1l6.1,8c-0.4,3.7-1.5,7.1-3.2,10.2L45.2,48.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/goal.245fa6c582ed35b6635a3f9aaf0f43fb.svg";
export { ForwardRef as ReactComponent };